interface SparkProps {
  data: number[];
  color?: string;
  width?: number;
  height?: number;
  fill?: string;
}

export function Spark({ data, color = "hsl(var(--ink))", width = 180, height = 44, fill }: SparkProps) {
  const min = Math.min(...data);
  const max = Math.max(...data);
  const pad = 4;
  const pts = data.map((v, i) => {
    const x = pad + (i / (data.length - 1)) * (width - pad * 2);
    const y = pad + (1 - (v - min) / (max - min || 1)) * (height - pad * 2);
    return [x, y] as const;
  });
  const line = pts.map(([x, y]) => `${x},${y}`).join(" ");
  const area = `${pad},${height - pad} ${line} ${width - pad},${height - pad}`;
  return (
    <svg width={width} height={height} style={{ display: "block" }}>
      {fill && <polygon points={area} fill={fill} opacity="0.25" />}
      <polyline
        points={line}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {pts.map(([x, y], i) =>
        i === pts.length - 1 ? <circle key={i} cx={x} cy={y} r="3" fill={color} /> : null,
      )}
    </svg>
  );
}
